import { render, staticRenderFns } from "./doctorDataAnalysis.vue?vue&type=template&id=f472b29a&scoped=true"
import script from "./doctorDataAnalysis.vue?vue&type=script&lang=js"
export * from "./doctorDataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./doctorDataAnalysis.vue?vue&type=style&index=0&id=f472b29a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f472b29a",
  null
  
)

export default component.exports